import { defineComponent } from "vue";
import LoginClientChatPacket from "../packets/client/LoginClientChatPacket";

export default defineComponent({
    template: `
        <div class="livechat__login">
            <form class="livechat__login-form">
                <span class="livechat__login-label">{{ options.i18n.yourname }}:</span>
                <input type="name" class="livechat__username" required v-model.trim="name" v-on:keydown.enter.prevent="onLogin">

                <button type="button" class="livechat__login-button livechat-button" @click="onLogin"><i class="fa fa-comment-alt"></i></button>
            </form>
        </div>
    `,

    props: {
        options: { type: Object, required: true },
        username: { type: String },
    },

    data() {
        return {
            name: this.username,
        };
    },

    watch: {
        username() {
            this.name = this.username;
        },
    },

    methods: {
        async onLogin() {
            if (!this.name) {
                return;
            }

            const r = await this.$root.sendPacket(new LoginClientChatPacket(this.name));

            this.$emit('login', this.name);
        },
    },
});
